import React from "react";
import { styled } from "@mui/material";
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import SaveIcon from "@mui/icons-material/Save";
import PrintIcon from "@mui/icons-material/Print";
import ShareIcon from "@mui/icons-material/Share";

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
  position: "fixed",
  bottom: 16,
  right: 16,
  ".MuiSpeedDial-fab": {
    backgroundColor: theme.palette.primary.main,
    boxShadow: theme.customShadows.primary,
  },
}));

const actions = [
  { icon: <FileCopyIcon />, name: "Copy" },
  { icon: <SaveIcon />, name: "Save" },
  { icon: <PrintIcon />, name: "Print" },
  { icon: <ShareIcon />, name: "Share" },
];

const MySpeedDial = () => {
  return (
    <StyledSpeedDial
      ariaLabel="SpeedDial basic example"
      icon={<SpeedDialIcon />}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          onClick={() => console.log("hello")}
          tooltipTitle={action.name}
        />
      ))}
    </StyledSpeedDial>
  );
};

export default MySpeedDial;
